import axios from "axios";
import JwtService from "@/common/jwt.service";
import store from "../store";
import router from "../router";

const api = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 300000,
  headers: {
    "Content-Type": "application/json",
  },
});

const errorInterceptor = (error) => {
  var date = new Date();
  if (date.getDay() == 0 && date.toLocaleTimeString() == "12:00:00 PM") {
    store.dispatch("logout");
  }
  if (!error.response) {
    return Promise.reject(error);
  }
  const originalRequest = error.config;
  const status = error.response.status;
  if (status === 401) {
    return store
      .dispatch("refresh")
      .then(() => {
        const headerAuthorization = `Bearer ${JwtService.getAccessToken()}`;
        api.defaults.headers.Authorization = headerAuthorization;
        originalRequest.headers.Authorization = headerAuthorization;
        return axios(originalRequest);
      })
      .catch((error) => {
        // if token refresh fails, logout the user to avoid potential security risks.
        store.dispatch("logout");
        return Promise.reject(error);
      });
  }
  return Promise.reject(error);
};

api.interceptors.request.use(function(config) {
  const token = JwtService.getAccessToken();
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  return config;
});

api.interceptors.response.use(
  (response) => response, // this is for all successful requests.
  (error) => errorInterceptor(error) // handle the request
);

export default api;
